import {cal} from './allReducers'
import {combineReducers} from 'redux';

const rootReducer=combineReducers({cal})

export default rootReducer;